import Text from '@zenbusiness/common-components/Text';
import Title from '@zenbusiness/common-components/Title';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

export const Tip = ({
  emoji, title, answer, className
}) => (
  <Box display="flex" className={className}>
    {emoji && (
      <Title
        variant="md-alt"
        sx={{ marginRight: '0.625rem' }}
      >
        {emoji}
      </Title>
    )}
    <div>
      <Text size="lg">
        <strong>{title}</strong>
      </Text>
      <Text size="lg">
        {answer}
      </Text>
    </div>
  </Box>
);

Tip.propTypes = {
  emoji: PropTypes.string,
  title: PropTypes.string,
  answer: PropTypes.string
};

Tip.defaultProps = {
  emoji: null,
  title: '',
  answer: ''
};
